import { getBranding, softRebrandColors } from "../../../../Themes/allThemes";
import { Brand } from "../../../../types";
import styled from "styled-components";
export const Circle = styled.div `
  background-color: ${(props) => {
    if (props.$complete && props.branding === Brand.DEFAULT) {
        return "transparent";
    }
    if (props.$complete && props.branding === Brand.SOFT_REBRAND) {
        return softRebrandColors.surfaceSuccess;
    }
    if (!props.$active && props.branding === Brand.DEFAULT) {
        return "var(--color-disabled-variant)";
    }
    return props.$active
        ? getBranding(props.branding).circle.backgroundColorActive
        : getBranding(props.branding).circle.backgroundColor;
}};
  border: ${(props) => props.$complete && props.branding === Brand.DEFAULT
    ? "1px solid var(--color-blue-50)"
    : ""};
  border-radius: 50%;
  height: 32px;
  padding: 16px;
  box-sizing: border-box;
  position: relative;
  width: 32px;
  margin-bottom: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${(props) => props.$active
    ? getBranding(props.branding).circle.textColorActive
    : getBranding(props.branding).circle.textColor};
`;
//# sourceMappingURL=styled.js.map